import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'redux-form'

export class SmsCode extends React.PureComponent {
  render () {
    return (
      <div className='sms-potvrda'>
        <Field
          id={`code-${this.props.index}`}
          name={`phones[${this.props.index}].code`}
          placeholder='UNESITE KOD'
          className='unesi-kod-input'
          component='input'
        />
        <button className='potvrdi-btn' type='button' data-id={this.props.index} onClick={this.props.onClick}>
          Potvrdi
        </button>
      </div>
    )
  }
}

SmsCode.propTypes = {
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
}

SmsCode.defaultProps = {
  index: 0
}
